import NLS                  from "dashboard/dist/Core/NLS";
import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    HELP_QUESTION_LOADING,
    HELP_QUESTION_LIST, HELP_QUESTION_ELEM, HELP_QUESTION_CREATE,
    HELP_QUESTION_DATA,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    position  : 0,
    sections  : [],
    help      : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate     = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.statusName      = Status.getName(elem.status);
    elem.statusColor     = Status.getColor(elem.status);
    elem.statusClass     = Status.getTextClass(elem.status);
    elem.questionShort   = elem.question.substr(0, 80) + (elem.question.length > 80 ? "..." : "");
    elem.accessTypeName  = NLS.get("QUESTIONS_ACCESS_TYPES", elem.accessType);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, HELP_QUESTION_LIST, HELP_QUESTION_ELEM, HELP_QUESTION_CREATE, HELP_QUESTION_DATA)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case HELP_QUESTION_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case HELP_QUESTION_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case HELP_QUESTION_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            elem      : parseElem(action.data.elem),
            sections  : action.data.sections,
        };

    case HELP_QUESTION_CREATE:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            position  : action.data.position,
            sections  : action.data.sections,
        };

    case HELP_QUESTION_DATA:
        return {
            ...state,
            error     : false,
            help      : action.data.help,
        };

    default:
        return state;
    }
};

export default reducer;
